;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="244cfc36-55cd-4811-86ee-03a8ebf91800",e._sentryDebugIdIdentifier="sentry-dbid-244cfc36-55cd-4811-86ee-03a8ebf91800")}catch(e){}}();import { CategoryTypeEnum } from '../../types/index.js';
import '../../_virtual/_sentry-release-injection-file.js';

const ROOT_PATH = '/shop';
const BOLD_LINKS_COUNT = 3;
function isBold(parentLevel, index, type) {
    // display first 3 links in Panel1 (level2) and Panel2 (level3)
    // when the category type is not of Brands
    return (type !== CategoryTypeEnum.BRANDS &&
        parentLevel !== 3 &&
        index < BOLD_LINKS_COUNT);
}
function isSeperator(parentLevel, index, type) {
    // make the last bold link in Panel2 (level3) to be a seperator
    // when the category type is not of Brands
    return (type !== CategoryTypeEnum.BRANDS &&
        parentLevel !== 3 &&
        index === BOLD_LINKS_COUNT - 1);
}
function toItem(category, special) {
    const { animalType, description, extId, level, path, title, type, children, specials, highlighted, active, } = category;
    const hasChildren = !!(children?.length || specials?.length);
    return {
        animalType,
        description,
        extId,
        level,
        path,
        title,
        type,
        highlighted,
        active: level !== 2 && active,
        hasChildren,
        isSpecial: special,
    };
}
function convertTrackingIdCategory(type) {
    switch (type) {
        case CategoryTypeEnum.ANIMAL:
            return `-animal`;
        case CategoryTypeEnum.BRANDS:
            return `-topBrands`;
        case CategoryTypeEnum.OFFERS:
            return `-specialOffers`;
        default:
            return '';
    }
}
function convertTrackingIdTitle(title) {
    return title
        .split(' ')
        .map((substr) => substr.replace(' ', '-'))
        .join('-');
}
function convertTrackingId(category, parentPanel, index) {
    if (category.level === 4)
        return undefined;
    let trackingId = 'header-category-mobile-menu';
    if (category.level === 3) {
        if (parentPanel.currentType) {
            trackingId += convertTrackingIdCategory(parentPanel.currentType);
        }
        trackingId += '-level4-links';
        if (parentPanel.currentTitle) {
            trackingId += `-${convertTrackingIdTitle(parentPanel.currentTitle)}`;
        }
        if (index !== undefined) {
            trackingId += `-${index}`;
        }
        trackingId += `-${convertTrackingIdTitle(category.title)}`;
    }
    if (category.level === 2) {
        if (category.type) {
            trackingId += convertTrackingIdCategory(category.type);
        }
        trackingId += '-level3-links';
        trackingId += `-${convertTrackingIdTitle(category.title)}`;
    }
    return trackingId;
}
function addCategoryPanels(category, parentPanel, panelMap, allProductsText, index) {
    const { animalType, description, extId, level, path, title, type, children = [], specials = [], highlighted, } = category;
    const panelItems = [];
    if (allProductsText) {
        const parent = {
            animalType,
            description,
            extId,
            level,
            path,
            title: `${allProductsText} ${title}`,
            type,
            highlighted,
            active: false,
            children: [],
            specials: [],
        };
        panelItems.push({ ...toItem(parent, false), isParent: true });
    }
    const childItems = children?.map((childCategory, index) => {
        return {
            ...toItem(childCategory, false),
            isBold: isBold(level, index, type),
            isSeperator: isSeperator(level, index, type),
            isParent: false,
        };
    });
    const specialItems = specials?.map((specialChildCategory, index) => {
        return {
            ...toItem(specialChildCategory, true),
            isBold: isBold(level, childItems.length + index, type),
            isSeperator: isSeperator(level, childItems.length + index, type),
            isParent: false,
        };
    });
    const { currentTitle: parentTitle, currentPath: parentPath } = parentPanel;
    const panel = {
        show: false,
        items: panelItems.concat(childItems, specialItems),
        currentTitle: title,
        currentPath: path,
        currentType: type,
        parentTitle,
        parentPath,
        trackingId: convertTrackingId(category, parentPanel, index),
    };
    panelMap.set(path, panel);
    children?.forEach((childCategory, childIndex) => addCategoryPanels(childCategory, panel, panelMap, allProductsText, childIndex));
    specials?.forEach((specialChildCategory, specialChildIndex) => addCategoryPanels(specialChildCategory, panel, panelMap, allProductsText, specialChildIndex));
}
function convertPanelMap(categories, allProductsText) {
    const panelMap = new Map();
    const rootPanel = {
        currentPath: ROOT_PATH,
        show: true,
        items: categories.map((category, index) => {
            return {
                ...toItem(category, false),
                isBold: index < BOLD_LINKS_COUNT,
                isParent: false,
            };
        }),
    };
    panelMap.set(ROOT_PATH, rootPanel);
    categories.forEach((category) => addCategoryPanels(category, rootPanel, panelMap, allProductsText));
    return panelMap;
}

export { ROOT_PATH, convertPanelMap, convertTrackingId };
//# sourceMappingURL=BurgerNavigationConverter.js.map
